module.exports = __webpack_public_path__ + "static/media/check_w.6699400e.svg";